import React from "react";
import { useTranslation } from "react-i18next";
import ModalShell from "../common/ModalShell";
import { buttonClasses } from "../common/tailwindClassnames";

type RemoveDestinationFromConnectionModalProps = {
    destinationName: string;
    onConfirm: () => void;
    onCancel: () => void;
};

const RemoveDestinationFromConnectionModal = ({
    destinationName,
    onConfirm,
    onCancel,
}: RemoveDestinationFromConnectionModalProps) => {
    const { t } = useTranslation();
    return (
        <ModalShell
            title={t("Remove destination?")}
            onClose={onCancel}
            footer={
                <>
                    <button
                        className={buttonClasses.destructive}
                        type="button"
                        data-testid="RemoveDestinationFromConnectionModal-confirm"
                        onClick={onConfirm}
                    >
                        {t("Remove destination")}
                    </button>
                    <button
                        className={buttonClasses.secondary}
                        type="button"
                        data-testid="RemoveDestinationFromConnectionModal-cancel"
                        onClick={onCancel}
                    >
                        {t("Cancel")}
                    </button>
                </>
            }
        >
            <p className="text-secondary-gray">
                {t("Are you sure you want to remove {{destinationName}} from this connection? The destination itself won't be removed and can be reconnected later.", { destinationName })}
            </p>
        </ModalShell>
    );
};

export default RemoveDestinationFromConnectionModal;
